module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('section', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body is-flex-start"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('logo-stats'), _c('top-bar', {
    on: {
      "go": _vm.goTo
    }
  }), _c('br'), _c('router-view', {
    key: _vm.keyGenerated
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43bc79bc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 375
// module chunks = 1